import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { rootRoute } from '../../../config';
import { motion } from "framer-motion";
import { play_simulation, save_simulation } from '../services/api';
import { errorMsg } from '../../../helper/helpers';
import Button from '../../common/Button'
import SimProgress from './SimProgress';
import CalProfitLoss from './CalProfitLoss';
import TaskCostGraph from './TaskCostGraph';
import AonGraph from './AonGraph';
import TasktimeGraph from './TasktimeGraph';
import { useOutletContext } from "react-router-dom";
import PmModuleStyle from '../styles/pm.module.css';
import info from '../assets/info.png';
import ReactDOM from 'react-dom';
import GraphDataTable from './GraphDataTable';
import ProjectedDays from './ProjectedDays';
import CalcAnimation from './CalcAnimation';
import ts_A from '../assets/ts_A.png';
import nodeB from '../assets/nodeB.png';

const Simulation = () => {
  const [quantity, setQuantity] = useState(50);
  const [shippingType, setShippingType] = useState("NORMAL_SHIPPING");
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, pmPopup, setPmPopup,setRelaunchPopup,focusPopUp,getTaskDataForGraph] = useOutletContext();
  const [isDecisionPopup, setIsDecisionPopup] = useState(false);
  const [isShowPlaceOrder, setIsShowPlaceOrder] = useState(false);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [point, setPoint] = useState(null);
  const [isEnabledSimulationBtn, setIsEnabledSimulationBtn] = useState(false);
  const [simObjCopy, setSimObjCopy] = useState({});
  const [copyUiDataObject, setCopyUiDataObject] = useState({});
  const [costParameters,setCostParameters] = useState([]);
  const [seriesStatus,setSeriesStatus]=useState([]);
  const [simulationRunning,setSimulationRunning] = useState(false);
  const [aonPopupTop, setAonPopupTop] = useState(0);
  const [aonPathsTop, setAonPathsTop] = useState(0);
  const [aonLabelsTop, setAonLabelsTop] = useState(0);
  const [simBtnPopupTop, setSimBtnPopupTop] = useState(0);
  const [graphPopupTop, setGraphPopupTop] = useState(0);
  const [kpiPopupTop, setKpiPopupTop] = useState(0);
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const showDecisionPopup = () => {
    setIsDecisionPopup(true);
  }
  const hideDecisionPopup = () => {
    setIsDecisionPopup(false);
    //var element = document.getElementById('RevenueGraph-Quality');
    //element.style.overflow = 'hidden';
  }
  const loadNextPoup = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setIsPopupShown(true);
    if (document.querySelector(".help-link") != null) {
      document.querySelector(".help-link").focus();
    }
  }

  const playSimulation = () => {
    setTimeout(() => {
      setToggleSimulation(true);
    }, 0);
  }

  const saveSimulation = ()=> {
    let copySimObj = {...simObjCopy};
    delete copySimObj.artifacts;
    delete copySimObj.graphdata;
    delete copySimObj.tasksInformation;
    if (!isRequestLoading && copySimObj?.actions?.taskOptions?.length == 26) {
      save_simulation(copySimObj?.sessionid, copySimObj).then((response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
        }
        else{
          if (typeof response != 'undefined') {
            setIsRequestLoading(false);
          }
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      })
    }
    
  }

  const resumeSimulation = () => {
      let copySimObj = {...simObjCopy};
      delete copySimObj.artifacts;
      delete copySimObj.graphdata;
      delete copySimObj.tasksInformation;
    if (!isRequestLoading) {
      setIsRequestLoading(true);
      play_simulation(copySimObj?.sessionid, copySimObj).then((response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          setError(response?.data)
        }
        else{
        if (typeof response != 'undefined') {
          setSimObj(response?.data);
          setIsShowPlaceOrder(false);
          setIsRequestLoading(false);
            if(response?.data?.laststate?.randomEventOccured){
              window.$(".email-link")[0]?.click();
            }
          // pauseSimulation();
        }
      }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
        console.log(error);
      })
    }
  }

  const pauseSimulation = () => {
    setToggleSimulation(false);
  }
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    // console.log("readcount:" + readStatusLength)
    if (simObj?.currentstep > 1 || simObj?.attemptno > 1 || readStatusLength > 0) {
      skipWalkThruPopups(false);
    }
  }
  const initSimulation = () => {
    if (!isPopupShown) {
      setIsOverlay(true);
      setHeaderPopup(true)
    }
    setIsArtifacts(true);
  }
  useEffect(() => {
    initSimulation();
    window.$('.ui.accordion').accordion();
    window.$('html, body').animate({
      scrollTop: 0
    }, 100);
    // document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
    document.title = "Project Management | Simulation";
    document.querySelector("header.header h1.title").focus();
    document.querySelector(".skip-to-main-content-link").style.display = "block";
    if (document.querySelector("#showSummary")) {
      document.querySelector("#showSummary").focus();
    }
    return () => {
      document.querySelector(".skip-to-main-content-link").style.display = "none";
    }
  }, []);

  const screenWidth = windowSize;
  const [periodicalType, setPeriodicalType] = useState("monthly");
  const funMonthlyHandler = (e) => {
    setPeriodicalType("monthly");
    setIsDecisionPopup(false);
  }
  const funQuarterlyHandler = (e) => {
    setPeriodicalType("quarterly");
    setIsDecisionPopup(false);
  }
  const funYearlyHandler = (e) => {
    setPeriodicalType("yearly");
    setIsDecisionPopup(false);
  }
  const [periodicalTypeFailure, setPeriodicalTypeFailure] = useState("monthly");
  const funMonthlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("monthly");
  }
  const funQuarterlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("quarterly");
  }
  const funYearlyHandlerFailure = (e) => {
    setPeriodicalTypeFailure("yearly");
  }
  const formatNum = (num) => {
    return num?.toLocaleString('en-US', { style: 'decimal' });
  }
  const checkNum = (num) => {
    return (!isNaN(num)) ? (num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`) : "";
  };
  useEffect(() => {
    fuSkipWalkThruPopups();
    // console.log(simObj)
  }, [simObj])

  const functionTabGraphControl = () => {
    class TabsManual {
      constructor(groupNode) {
        this.tablistNode = groupNode;

        this.tabs = [];

        this.firstTab = null;
        this.lastTab = null;

        this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
        this.tabpanels = [];

        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

          tab.tabIndex = -1;
          tab.setAttribute('aria-selected', 'false');
          this.tabpanels.push(tabpanel);

          tab.addEventListener('keydown', this.onKeydown.bind(this));
          tab.addEventListener('click', this.onClick.bind(this));

          if (!this.firstTab) {
            this.firstTab = tab;
          }
          this.lastTab = tab;
        }

        this.setSelectedTab(this.firstTab);
      }

      setSelectedTab(currentTab) {
        for (var i = 0; i < this.tabs.length; i += 1) {
          var tab = this.tabs[i];
          if (currentTab === tab) {
            tab.setAttribute('aria-selected', 'true');
            tab.removeAttribute('tabindex');
            //this.tabpanels[i].classList.remove('is-hidden');
          } else {
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            //this.tabpanels[i].classList.add('is-hidden');
          }
        }
      }

      moveFocusToTab(currentTab) {
        currentTab.focus();
      }

      moveFocusToPreviousTab(currentTab) {
        var index;

        if (currentTab === this.firstTab) {
          this.moveFocusToTab(this.lastTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index - 1]);
        }
      }

      moveFocusToNextTab(currentTab) {
        var index;

        if (currentTab === this.lastTab) {
          this.moveFocusToTab(this.firstTab);
        } else {
          index = this.tabs.indexOf(currentTab);
          this.moveFocusToTab(this.tabs[index + 1]);
        }
      }

      /* EVENT HANDLERS */

      onKeydown(event) {
        var tgt = event.currentTarget,
          flag = false;

        switch (event.key) {
          case 'ArrowLeft':
            this.moveFocusToPreviousTab(tgt);
            flag = true;
            break;

          case 'ArrowRight':
            this.moveFocusToNextTab(tgt);
            flag = true;
            break;

          case 'Home':
            this.moveFocusToTab(this.firstTab);
            flag = true;
            break;

          case 'End':
            this.moveFocusToTab(this.lastTab);
            flag = true;
            break;

          default:
            break;
        }

        if (flag) {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      // Since this example uses buttons for the tabs, the click onr also is activated
      // with the space and enter keys
      onClick(event) {
        this.setSelectedTab(event.currentTarget);
      }
    }
    // window.addEventListener('load', function () {
    //   var tablists = document.querySelectorAll('[role=tablist].Graphs');
    //   for (var i = 0; i < tablists.length; i++) {
    //     new TabsManual(tablists[i]);
    //   }
    //   if(document.querySelectorAll('.Graphs button') != null){
    //     const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
    //     elementsWithClassGraphs.forEach(element => {
    //         if (element.getAttribute('aria-selected') === 'false') {
    //             element.setAttribute('tabindex', '-1');
    //         }
    //     });
    //   }
    // });
    const initTabs = () => {
      var tablists = document.querySelectorAll('[role=tablist].Graphs');
      for (var i = 0; i < tablists.length; i++) {
        new TabsManual(tablists[i]);
      }
      if (document.querySelectorAll('.Graphs button') != null) {
        const elementsWithClassGraphs = document.querySelectorAll('.Graphs button');
        elementsWithClassGraphs.forEach(element => {
          if (element.getAttribute('aria-selected') === 'false') {
            element.setAttribute('tabindex', '-1');
          }
        });
      }
    }
    initTabs()
  }
  useEffect(() => {
    functionTabGraphControl();
  }, [])


    useEffect(() => {
      const handleResize = () => {
        const aonGraphElement = document.getElementById('AonGraph');
        if (aonGraphElement) {
          if (window.innerWidth <= 1080) {
            // Apply styles when the width is 1080 pixels or less
            aonGraphElement.style.width = '100%';
            aonGraphElement.style.overflowX = 'auto';
          } else {
            // Reset styles when the width is greater than 1080 pixels
            aonGraphElement.style.width = '';
            aonGraphElement.style.overflowX = '';
          }
        }
      };
    // Initial setup
    handleResize();

    // Attach event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    const handleResize1 = ()=> {
        if((pmPopup?.aonDiagram || pmPopup?.aonPaths || pmPopup?.aonLabels) && document.getElementsByClassName("ui pointing label")[0] != null){
          let top = document.getElementsByClassName(`${PmModuleStyle['make-decision-activity']}`)[0].offsetTop + document.getElementsByClassName(`${PmModuleStyle['make-decision-activity']}`)[0].clientHeight;
          if(pmPopup?.aonDiagram){
            setAonPopupTop(top); 
          }
          if(pmPopup?.aonPaths){
            setAonPathsTop(top);
          }
          if(pmPopup?.aonLabels){
            setAonLabelsTop(top);  
          }
        }
        if(pmPopup?.taskSelectorA && document.querySelector('.ts1-popup') && window.$(`.node1`)){
          let top = window.$(`.node1`).offset().top + document.querySelector(`.node1`).querySelector("img").clientHeight - 50;
          document.querySelector('.ts1-popup').style.top = top+"px"
        }
        if(pmPopup?.taskSelectorB && document.querySelector(`.ts2-popup`) && window.$(`.node2`)){
          let top = window.$(`.node2`).offset().top - 265;
          if(window.innerWidth <=440){
            top=top-20
          }
          document.querySelector(`.ts2-popup`).style.top = top+"px";
        }
        if(pmPopup?.firstNode && window.innerWidth>1024 && document.querySelector(`.first-node-popup`)){
          let left = window.$(`#simProgressActivity`).width()+8;
          document.querySelector(`.first-node-popup`).style.left = left+"px"
        }
        else if(pmPopup?.firstNode && window.innerWidth<1024 && document.querySelector(`.first-node-popup`)){
          document.querySelector(`.first-node-popup`).style.removeProperty('left');
        }
        if(pmPopup?.pmSimBtn && document.getElementsByClassName("ui pointing label")[0] != null){
          let top = document.getElementsByClassName(`${PmModuleStyle["make-decision-activity"]}`)[0].offsetTop + document.getElementsByClassName(`${PmModuleStyle["sim-progress-activity"]}`)[0].clientHeight - document.getElementsByClassName(`${PmModuleStyle["simmsg-container"]}`)[0].clientHeight;
          setSimBtnPopupTop(top);
        }
        if(pmPopup?.pmGraphs && document.getElementsByClassName("ui pointing label")[0] != null){
          let top = document.getElementsByClassName(`${PmModuleStyle['graph-wrapper']}`)[0].offsetTop - document.getElementsByClassName("ui pointing label")[0].clientHeight - 20;
          setGraphPopupTop(top);
        }
        if(pmPopup?.pmKpis && document.getElementsByClassName("ui pointing label")[0] != null){
          let top = document.getElementsByClassName(`${PmModuleStyle['kps-wrapper']}`)[0].clientHeight;
          setKpiPopupTop(top);
        }

    }
    window.addEventListener('resize', handleResize1);
    handleResize1();
  }, [pmPopup?.taskSelectorA, pmPopup?.taskSelectorB, pmPopup?.firstNode, pmPopup?.aonDiagram, pmPopup?.aonPaths, pmPopup?.aonLabels, pmPopup?.pmSimBtn, pmPopup?.pmGraphs, pmPopup?.pmKpis]);

  const openNewWindow = (data) => {
    const newWindow = window.open('', '_blank', 'width=800,height=800');
    if (newWindow) {
      newWindow.document.open();
      const htmlContentWithNbsp = `
<!DOCTYPE html>
<html>
<head>
    <title>Quality Management</title>
    <link rel="stylesheet" type="text/css" href="https://cdn.datatables.net/1.13.6/css/jquery.dataTables.min.css">
    <style>
          .MainDiv {
              min-height: 620px;
              overflow: hidden;
              width: 95%;
              margin: 0 auto;
          }
          .MainDivChild {
              overflow-x: auto;
              margin: 10px auto;
          }
          table.dataTable thead th {
            border: 1px solid rgba(0, 0, 0, 0.3);
            background-color: #f0f0f0;
          }
          .dataTables_length {
              min-width: 5.5em;
              padding: 10px;
          }
          .dataTables_filter {
            min-width: 5.5em;
            padding: 10px;
            text-align: left;
          }
          .table {
              width: 100%;
              max-width: 100%;
              margin-bottom: 20px;
          }
          .headingh3 {
              color: #002D5F;
              font-weight: 700;
              font-size: 22px;
              background: transparent;
              padding: 0;
          }
          header.header {
            box-shadow: 0px 1px 2px 0px #CCCCCC;
            color: #012F61;
            position: relative;
          }
          header.header>.container {
            margin: 0px 20px;
            display: flex;
            justify-content: space-between;
            min-height: 60px;
            align-items: center;
          }
          header.header>.container h1 {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #b2347b;
          }
          table.dataTable thead th {
              color: #002D5F;
          }
          .header-container header {
          font-size: 12px;
          color: #b2347b;
          }
          .footer {
              background-color: #CDCDCD;
              font-size: 12px;
              padding: 6px;
              text-align: center;
              color: #000000;
          }
          .footer .container {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 82.5%;
              margin: auto;
          }
          .footer .container>div {
              display: flex;
          }
          .footer-links {
              list-style-type: none;
              padding-left: 0;
              padding: 0 5px;
              margin: 0;
              display: flex;
          }
          .footer-links .listitem a {
              text-decoration: underline;
              color: #000000;
          }
          #RevenueGraphData th {
            padding: 4px; 
          }
          #RevenueGraphData tr td:first-child {
            width: 45px; 
          }
    </style>
</head>
<body style="font: 16px/26px 'Roboto', 'Helvetica Neue', Helvetica, Arial; -webkit-font-smoothing: antialiased; font-weight: 300;margin:0;">
<div id="new-component-root"></div>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js"></script>
<script>
    document.addEventListener('DOMContentLoaded', function() {
        $('#RevenueGraphData').DataTable({
            pagingType: 'full_numbers'
        });
        $('#FailureGraphData').DataTable({
            pagingType: 'full_numbers'
        });
    });
</script>
</body>
</html>
`;
      const htmlContentWithoutNbsp = htmlContentWithNbsp.replace(/&nbsp;/g, ' ');


      newWindow.document.write(htmlContentWithoutNbsp);
      ReactDOM.render(<GraphDataTable type={periodicalType} simObj={simObj} setSimObj={setSimObj} />, newWindow.document.getElementById("new-component-root"));
      newWindow.document.close();
    }
  };

useEffect(()=>{
  setTimeout(() => {
    setSimulationRunning(toggleSimulation)
  }, 100);
},[toggleSimulation])

//Added for stylus tool
useEffect(() => {
  const checkStyleTag = () => {
    const styleTag = document.querySelector('style.stylus');
    setIsStyleTagPresent(!!styleTag);  // Updates the state to true if the tag is found, false otherwise
  };
  checkStyleTag();
  // Optionally, if the tag might be dynamically added, use a MutationObserver or setInterval
  const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
  return () => clearInterval(intervalId);  // Clean up interval when component unmounts
}, []);


  return (
    <motion.div className={`${PmModuleStyle.simulation} ${PmModuleStyle.container}`} id={`${isStyleTagPresent ? `${PmModuleStyle['pmStylus']}` : ''}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${PmModuleStyle.introtext}`}>
        <h2 className={`${PmModuleStyle.heading} ${PmModuleStyle.bgpurple} ${PmModuleStyle.imSim}`}>Simulation</h2>
        <p>Your goal is to retain {simObj?.laststate?.profitPercentage}% of the project cost for profit and complete the project on time. Conduct your work in two phases: Planning (select all sub-contractors on the project diagram) and Execution (start the sim, then keep an eye on incoming messages to revise your project plan as necessary). </p>
        {/* Click &nbsp;
        <Link to={`${rootRoute}/${simType?.toLowerCase()}?from=simulation`} style={{'color':'#000','text-decoration':'underline','font-weight':'bold'}}>
          <em className="info circle icon" aria-hidden="true" role="presentation"></em>
          <span>here</span>
        </Link>
        &nbsp;to revisit the tutorial.</p> */}
      </div>
      {
        pmPopup?.firstNode ? <div className={`ui pointing label ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['first-node-popup']} first-node-popup`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Node A popup">
            <p>To begin the Planning Phase, click each node to see the contractor options and make your selections.</p>
            <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
            <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setPmPopup((prevScmPopup) => ({...prevScmPopup, ['firstNode'] : false, ['taskSelectorA'] : true}));  
            }} />
            </div>
        </div> : ''
      }

        {
          pmPopup?.taskSelectorA && <div className={`${PmModuleStyle.node1} node1`}><img src={ts_A} /></div>
        }

      {
        pmPopup?.taskSelectorA ? <div className={`ui pointing label ts1-popup ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['ts1-popup']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Task Selector popup">
            <p>Each contractor provides a price and a time estimate. Click the one you want to hire for that task and click Save. You can also Select Expedite Options to reduce the task time, but for an extra cost.</p>
            <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
            <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setPmPopup((prevScmPopup) => ({...prevScmPopup, ['taskSelectorA'] : false, ['taskSelectorB'] : true}));
            }} />
            </div>
        </div> : ''
      }
       {
          pmPopup?.taskSelectorB && <div className={`${PmModuleStyle.node2} node2`}><img src={nodeB} /></div>
        }
      {
          pmPopup?.taskSelectorB ? <div className={`ui pointing label ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['ts2-popup']} ts2-popup`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Task selector B popup">
              <p>Keep in mind that some contractors, like the Plumber you select in Task B, will be used again for later tasks. Once the work begins in Task B, you cannot change this contractor.</p>
              <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
              <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
              <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                  setPmPopup((prevScmPopup) => ({...prevScmPopup, ['taskSelectorB'] : false, ['aonPaths'] : true}))
              }} />
              </div>
          </div> : ''
      }

      <div className={`${PmModuleStyle['activities']}`}>
        <div className={`${PmModuleStyle['meters-wrapper']}`}>
        <div className={`${PmModuleStyle['kps-wrapper']} ${pmPopup?.pmKpis ? `show ${PmModuleStyle['show']}` : ''}`}>
            <CalProfitLoss simObj={simObj} setSimObj={setSimObj} pmPopup={pmPopup} setPmPopup={setPmPopup} costParameters={costParameters}/>
            <ProjectedDays simObj={simObj} costParameters={costParameters} simulationRunning={simulationRunning}/>
          </div>
          <CalcAnimation />
        </div>
          {
            pmPopup?.pmKpis ? <div className={`ui pointing label ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['kpi-popup']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Key Performance Indicators popup" style={{top: kpiPopupTop+"px"}}>
                <p>
                  {`Your main goal is to achieve profits of ${simObj?.laststate?.profitPercentage}% (spend ${checkNum(simObj?.laststate?.spendTarget)} or less of budget) and finish within ${simObj?.laststate?.deadLineDays} days. Keep an eye on how you're doing against these Key Performance Indicators (KPIs) here.`}
                </p>
                <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                    setPmPopup((prevScmPopup) => ({...prevScmPopup, ['pmKpis'] : false}));
                    setRelaunchPopup(true);
                }} />
                </div>
            </div> : ''
          }

        <hr className={`${PmModuleStyle['mt0']} ${PmModuleStyle['hr-bolder']}`} aria-hidden="true" role="presentation" />
        <div className={`${PmModuleStyle['make-decision-activity']}`}>
          <SimProgress actions={[playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation, isShowPlaceOrder,isEnabledSimulationBtn, setIsEnabledSimulationBtn]} popupState={[simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error, isRequestLoading, pmPopup, setPmPopup]} />
          <div id="AonGraph" className={`${pmPopup?.aonDiagram ? `show ${PmModuleStyle['show']}` : ''}`}>
            <AonGraph simObj={simObj} setSimObj={setSimObj} simObjCopy={simObjCopy} setSimObjCopy={setSimObjCopy} isEnabledSimulationBtn={isEnabledSimulationBtn} setIsEnabledSimulationBtn={setIsEnabledSimulationBtn} setToggleSimulation={setToggleSimulation} pmPopup={pmPopup} setPmPopup={setPmPopup} skipWalkThruPopups={skipWalkThruPopups} focusPopUp={focusPopUp} copyUiDataObject={copyUiDataObject} setCopyUiDataObject={setCopyUiDataObject} setCostParameters={setCostParameters} saveSimulation={saveSimulation}/>
          </div>
        </div>
        {
            pmPopup?.aonDiagram ? <div className={`ui pointing label ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['aon-graph-popup']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Activities On Node Diagram popup" style={{top: aonPopupTop+"px"}}>
                <p>This Activities On Node (AON) Diagram represents the entire project timeline. Each node in the AON diagram represents a task.</p>
                <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                    setPmPopup((prevScmPopup) => ({...prevScmPopup, ['aonDiagram'] : false, ['firstNode'] : true}))
                    let target = document.querySelector("#AonGraph");
                    target.scrollTo(0,0);
                }} />
                </div>
            </div> : ''
          }
          {
            pmPopup?.aonPaths ? <div className={`ui pointing label ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['aon-paths-popup']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Critical path legends popup" style={{top:aonPathsTop+"px"}}>
                <p>Pay special attention to the Critical Path. This represents the longest path (in time) from start to finish and gives you the best idea of the total time length of your project.</p>
                <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                    setPmPopup((prevScmPopup) => ({...prevScmPopup, ['aonPaths'] : false, ['aonLabels'] : true}))
                    if(window.innerWidth <= 360){
                      let target = document.querySelector("#AonGraph");
                      target.scrollTo(80,0);
                    }
                }} />
                </div>
            </div> : ''
          }
          {
            pmPopup?.aonLabels ? <div className={`ui pointing label ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['aon-labels-popup']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="AON legends popup" style={{top:aonLabelsTop+"px"}}>
                <p>Pay attention to the key to know which tasks are unplanned, planned, in progress, or completed.</p>
                <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                    setPmPopup((prevScmPopup) => ({...prevScmPopup, ['aonLabels'] : false, ['pmSimBtn'] : true}))
                }} />
                </div>
            </div> : ''
          }
          {
            pmPopup?.pmSimBtn ? <div className={`ui pointing label ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['sim-btn-popup']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Simulation progress popup" style={{top:simBtnPopupTop+"px"}}>
                <p>Once you've selected all contractors for all tasks, click Start Simulation. This is now the Execution Phase. Time will begin to pass and the tasks will begin to be completed in order.</p>
                <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                    setPmPopup((prevScmPopup) => ({...prevScmPopup, ['pmSimBtn'] : false, ['pmGraphs'] : true}))
                }} />
                </div>
            </div> : ''
          }
        {/* {screenWidth <= 768 &&
          <hr className={`${PmModuleStyle['show-hr']}`} aria-hidden="true" role="presentation"/>
        } */}
      </div>
      <hr className={`${PmModuleStyle['mt0']} ${PmModuleStyle['hr-bolder']}`} aria-hidden="true" role="presentation" />
      {
        pmPopup?.pmGraphs ? <div className={`ui pointing label ${PmModuleStyle.ui} ${PmModuleStyle.pointing} ${PmModuleStyle.label} ${PmModuleStyle['pm-graphs-popup']}`} role='dialog' tabIndex={-1} aria-modal="true" aria-label="Task time and task cost graphs popup" style={{top:graphPopupTop+'px'}}>
            <p>
              Keep an eye on these charts that illustrate the planned vs actual cost and time length. Watch out for any issues that may come up, such as weather delays
              or work stoppages. If you encounter these you can proactively make changes to tasks in the project diagram that come later. But keep in mind your budget and timeline!
            </p>
            <div className={`${PmModuleStyle.mt10} ${PmModuleStyle.dflex}`}>
            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
            <Button btnName="Next" btnId="btnNext" btnParentClassName={`${PmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                setPmPopup((prevScmPopup) => ({...prevScmPopup, ['pmGraphs'] : false, ['pmKpis'] : true}))
            }} />
            </div>
        </div> : ''
      }
      <div className={`graph-wrapper ${PmModuleStyle['graph-wrapper']} ${pmPopup?.pmGraphs ? `show ${PmModuleStyle['show']}` : ''}`}>
        <div className={`${PmModuleStyle['_graph']}`} id="APERangeGraph">
          <div className={`${PmModuleStyle['options']}`}>
            <h3 id="APE" className={`${PmModuleStyle['APE-heading']}`}>Task Cost</h3>
          </div>
          <TaskCostGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} seriesStatus={seriesStatus}  setSeriesStatus={setSeriesStatus} />
          <div className={`${PmModuleStyle['taskcostGraph-legend']}`} ><span className={`${PmModuleStyle['taskcost-legend1']} ${PmModuleStyle['taskcostpattern']}`} aria-hidden="true"><div className={`${PmModuleStyle['legend-sign1']}`}></div></span><div>Expected Task Cost</div> <span aria-hidden="true">&nbsp;&nbsp;</span><span className={`${PmModuleStyle['taskcost-legend2']} ${PmModuleStyle['taskcostpattern']}`} aria-hidden="true"><div className={`${PmModuleStyle['legend-sign2']}`}></div></span><div>Actual Task Cost</div></div>
        </div>

        <div className={`${PmModuleStyle['_graph']}`} id="Tracking-signal">
          <div className={`${PmModuleStyle['options']}`}>
            <h3 id="Tracking" className={`${PmModuleStyle['APE-heading']}`}>Task Time</h3>
          </div>
          <TasktimeGraph type={periodicalType} isDecisionPopup={isDecisionPopup} showDecisionPopupHandler={showDecisionPopup} hideDecisionPopupHandler={hideDecisionPopup} simObj={simObj} setSimObj={setSimObj} point={point} setPoint={setPoint} seriesStatus={seriesStatus}  setSeriesStatus={setSeriesStatus} getTaskDataForGraph={getTaskDataForGraph} simObjCopy={simObjCopy}/>
          <div className={`${PmModuleStyle['taskcostGraph-legend']}`} ><span className={`${PmModuleStyle['taskcost-legend1']} ${PmModuleStyle['taskcostpattern']}`} aria-hidden="true"><div className={`${PmModuleStyle['legend-sign1']}`}></div></span><div>Expected Task Time</div> <span aria-hidden="true">&nbsp;&nbsp;</span><span className={`${PmModuleStyle['taskcost-legend2']} ${PmModuleStyle['taskcostpattern']}`} aria-hidden="true"><div className={`${PmModuleStyle['legend-sign2']}`}></div></span><div>Actual Task Time</div></div>
        </div>
      </div>
    </motion.div>

  )
}

export default Simulation